<div class="menubar-hoverable header-fixed menubar-pin "
  style="font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;font-size: 13px;line-height: 1.846153846;color: #313534;background-color: #ffffff;">
  <!-- header -->
  <!--  -->


  <!-- BEGIN BASE-->
  <div id="base">

    <!-- BEGIN OFFCANVAS LEFT -->
    <div class="offcanvas">
    </div><!--end .offcanvas-->
    <!-- END OFFCANVAS LEFT -->

    <!-- BEGIN CONTENT-->
    <div id="content">
      <section>

        <div class="row">
          <div class="col-lg-12">
            <h2 class="text-primary" style="margin-bottom: 5px;">
              <!-- <img src="images_ext/logo1.png" class="img-respoonsive" style="width: 50px;"> --> New Admission</h2>
          </div><!--end .col -->
          <div class="col-lg-6">
            <article class="margin-bottom-xxl">
              <p class="lead" style="color: #828282;">
                Create new admissions here.
              </p>
              <!-- <button (click)="checkdata()">Check</button>-->
            </article>
          </div><!--end .col -->
        </div>

        <!-- BEGIN FORM WIZARD -->
        <div class="row particles-bg">
          <div class="col-lg-12">
            <div class="">
              <div class="">
                <!-- <div class="row particles-bg" style="text-align: center;max-height: 100px;">
                                    <div class="col-md-12" style="position: absolute;top: 0;left: 0;right: 0;padding-top: 4em;">
                                        <h3 style="font-weight: 100;margin: 0;color: #777777;">Add a new student</h3>
                                        <h4 style="color: #6b6b6b;font-weight: 300;">Create new student details here</h4>
                                    </div>
                                </div> -->
                <div id="rootwizard1" class="form-wizard form-wizard-horizontal" style="">
                  <form class="form">
                    <div class="form-wizard-nav col-xs-1">
                      <!-- <div class="progress"><div class="progress-bar progress-bar-primary"></div></div> -->
                      <ul class="nav nav-justified" style="position: fixed;margin-top: 5em;">
                        <li style="display: inherit;" class="" [class.active]="tab1activestatus"
                          [class.done]="tab1donestatus">
                          <a><!--href="#tab1" data-toggle="tab"-->
                            <p class="tab-tag" style="display:none;position: absolute;margin-top: -4px;"><span
                                style="background: var(--select-bg-color);color: white;padding: 2px 15px 2px 20px;border-radius: 10px;font-size: 10px;">Student_Info</span>
                            </p>
                            <p class="tab-tag2" style="position: absolute;margin-top: -4px;"><span
                                style="background: #d6d6d6;color: white;padding: 2px 20px 2px 20px;border-radius: 10px;font-size: 10px;">Student_Info</span>
                            </p>
                          </a>
                          <a><span class="step"></span></a><!-- href="#tab1" data-toggle="tab"-->
                        </li>
                        <li style="display: inherit;" [class.active]="tab2activestatus" [class.done]="tab2donestatus">
                          <a><!-- href="#tab2" data-toggle="tab"-->
                            <p class="tab-tag" style="display:none;position: absolute;margin-top: -4px;"><span
                                style="background: var(--select-bg-color);color: white;padding: 2px 20px 2px 20px;border-radius: 10px;font-size: 10px;">Parent_Info</span>
                            </p>
                            <p class="tab-tag2" style="position: absolute;margin-top: -4px;"><span
                                style="background: #d6d6d6;color: white;padding: 2px 20px 2px 20px;border-radius: 10px;font-size: 10px;">Parent_Info</span>
                            </p>
                          </a>
                          <a><span class="step"></span></a><!-- href="#tab2" data-toggle="tab"-->
                        </li>
                        <!--  <li style="display: inherit;">
                           <p class="tab-tag" style="display:none;position: absolute;margin-top: -4px;"><span style="background: var(--select-bg-color);color: white;padding: 2px 25px 2px 20px;border-radius: 10px;font-size: 10px;">Admission</span></p>
                           <a href="#tab3" data-toggle="tab"><span class="step"></span></a>
                       </li> -->
                        <li style="display: inherit;" [class.active]="tab4activestatus" [class.done]="tab4donestatus">
                          <a><!-- href="#tab4" data-toggle="tab"-->
                            <p class="tab-tag" style="display:none;position: absolute;margin-top: -4px;"><span
                                style="background: var(--select-bg-color);color: white;padding: 2px 30px 2px 20px;border-radius: 10px;font-size: 10px;">Transport</span>
                            </p>
                            <p class="tab-tag2" style="position: absolute;margin-top: -4px;"><span
                                style="background: #d6d6d6;color: white;padding: 2px 30px 2px 20px;border-radius: 10px;font-size: 10px;">Transport</span>
                            </p>
                          </a>
                          <a><span class="step"></span></a><!-- href="#tab4" data-toggle="tab"-->
                        </li>
                        <li style="display: inherit;" [class.active]="tab5activestatus" [class.done]="tab5donestatus">
                          <a><!-- href="#tab5" data-toggle="tab"-->
                            <p class="tab-tag" style="display:none;position: absolute;margin-top: -4px;"><span
                                style="background: var(--select-bg-color);color: white;padding: 2px 45px 2px 20px;border-radius: 10px;font-size: 10px;">Finish</span>
                            </p>
                            <p class="tab-tag2" style="position: absolute;margin-top: -4px;"><span
                                style="background: #d6d6d6;color: white;padding: 2px 45px 2px 20px;border-radius: 10px;font-size: 10px;">Finish</span>
                            </p>
                          </a>
                          <a><span class="step"></span></a><!-- href="#tab5" data-toggle="tab"-->
                        </li>
                      </ul>
                    </div><!--end .form-wizard-nav -->


                    <div class="tab-content clearfix col-xs-11">
                      <div class="tab-pane active card animated bounceInRight" id="tab1"
                        style="padding: 15px 15px 30px 15px;">
                        <div class="col-md-12" style="border-bottom: 1px  solid #e6e6e6;margin-bottom: 15px;">
                          <h3 style="font-weight: 100;margin: 0;color: #777777;">Add student & admission details</h3>
                          <h6 style="color: #b9b9b9;font-weight: 300;margin-top: 5px;"><span
                              style="color: #F44336;">*</span>mandatory fields</h6>
                        </div>
                        <div class="col-md-12 scrollbar-style"
                          style="min-height: 50vh;max-height: 50vh;overflow: auto;">
                          <div class="row" style="margin: 0;">
                            <div class="col-md-3">
                              <div class="form-group">
                                <input [(ngModel)]="mStudentName" [ngModelOptions]="{standalone: true}" type="text"
                                  class="form-control" id="admission-student-name">
                                <label for="admission-student-name">Student name<span
                                    style="color: #F44336;">*</span></label>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <input [(ngModel)]="mSurName" [ngModelOptions]="{standalone: true}" type="text"
                                  class="form-control" id="admission-surname">
                                <label for="admission-surname">Surname</label>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <select [(ngModel)]="mGenderGroup" [ngModelOptions]="{standalone: true}"
                                  id="admission-gender-group" name="select1" class="form-control"
                                  style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                                  <option id="admission-gender-male" value="male">Male</option>
                                  <option id="admission-gender-female" value="female">Female</option>
                                </select>
                                <label for="admission-gender-group">Gender<span style="color: #F44336;">*</span></label>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <input [(ngModel)]="mDOB" [ngModelOptions]="{standalone: true}" type="text"
                                  class="form-control" id="admission-dob" style="text-transform: initial;"
                                  data-provide="datepicker" data-date-format="mm/dd/yyyy">
                                <label for="admission-dob">Date of birth<span style="color: #F44336;">* </span>
                                  (mm/dd/yyyy )</label>
                              </div>
                            </div>

                            <div class="col-md-3">
                              <div class="form-group">
                                <select [(ngModel)]="mBloodGroup" [ngModelOptions]="{standalone: true}"
                                  id="admission-blood-group" name="select1" class="form-control"
                                  style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                                  <option value="A+">A+</option>
                                  <option value="A-">A-</option>
                                  <option value="B+">B+</option>
                                  <option value="B-">B-</option>
                                  <option value="AB+">AB+</option>
                                  <option value="AB-">AB-</option>
                                  <option value="O+">O+</option>
                                  <option value="O-">O-</option>
                                </select>
                                <label for="admission-blood-group">Blood Group<span
                                    style="color: #F44336;">*</span></label>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <select [(ngModel)]="mReligion" [ngModelOptions]="{standalone: true}"
                                  id="admission-religion" name="select1" class="form-control"
                                  style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                                  <option value="Hindu">Hindu</option>
                                  <option value="Christian">Christian</option>
                                  <option value="Muslim">Muslim</option>
                                  <option value="Other">Other</option>

                                </select>
                                <label for="admission-religion">Religion</label>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <input [(ngModel)]="mCast" [ngModelOptions]="{standalone: true}" type="text"
                                  class="form-control" id="admission-cast">
                                <label for="admission-cast">Caste Category</label>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <select [(ngModel)]="mNationality" [ngModelOptions]="{standalone: true}"
                                  id="admission-nationality" name="select1" class="form-control"
                                  style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                                  <option value="Afghan">Afghan</option>
                                  <option value="Albanian">Albanian</option>
                                  <option value="Algerian">Algerian</option>
                                  <option value="Andorran">Andorran</option>
                                  <option value="Angolan">Angolan</option>
                                  <option value="Argentinian">Argentinian</option>
                                  <option value="Armenian">Armenian</option>
                                  <option value="Australian">Australian</option>
                                  <option value="Austrian">Austrian</option>
                                  <option value="Azerbaijani">Azerbaijani</option>
                                  <option value="Bahamian">Bahamian</option>
                                  <option value="Bangladeshi">Bangladeshi</option>
                                  <option value="Barbadian">Barbadian</option>
                                  <option value="Belorussian">Belorussian</option>
                                  <option value="Belgian">Belgian</option>
                                  <option value="Beninese">Beninese</option>
                                  <option value="Bhutanese">Bhutanese</option>
                                  <option value="Bolivian">Bolivian</option>
                                  <option value="Bosnian">Bosnian</option>
                                  <option value="Brazilian">Brazilian</option>
                                  <option value="Briton">Briton</option>
                                  <option value="Bruneian">Bruneian</option>
                                  <option value="Bulgarian">Bulgarian</option>
                                  <option value="Burmese">Burmese</option>
                                  <option value="Burundian">Burundian</option>
                                  <option value="Cambodian">Cambodian</option>
                                  <option value="Cameroonian">Cameroonian</option>
                                  <option value="Canadian">Canadian</option>
                                  <option value="Chadian">Chadian</option>
                                  <option value="Chilean">Chilean</option>
                                  <option value="Chinese">Chinese</option>
                                  <option value="Colombian">Colombian</option>
                                  <option value="Congolese">Congolese</option>
                                  <option value="Croatian">Croatian</option>
                                  <option value="Cuban">Cuban</option>
                                  <option value="Cypriot">Cypriot</option>
                                  <option value="Czech">Czech</option>
                                  <option value="Dane">Dane</option>
                                  <option value="Dominican">Dominican</option>
                                  <option value="Ecuadorean">Ecuadorean</option>
                                  <option value="Egyptian">Egyptian</option>
                                  <option value="Salvadorean">Salvadorean</option>
                                  <option value="Englishman">Englishman</option>
                                  <option value="Eritrean">Eritrean</option>
                                  <option value="Estonian">Estonian</option>
                                  <option value="Ethiopian">Ethiopian</option>
                                  <option value="Fijian">Fijian</option>
                                  <option value="Finn">Finn</option>
                                  <option value="Frenchman">Frenchman</option>
                                  <option value="Gabonese">Gabonese</option>
                                  <option value="Gambian">Gambian</option>
                                  <option value="Georgian">Georgian</option>
                                  <option value="German">German</option>
                                  <option value="Ghanaian">Ghanaian</option>
                                  <option value="Greek">Greek</option>
                                  <option value="Grenadian">Grenadian</option>
                                  <option value="Guatemalan">Guatemalan</option>
                                  <option value="Guinean">Guinean</option>
                                  <option value="Guyanese">Guyanese</option>
                                  <option value="Haitian">Haitian</option>
                                  <option value="Dutchman">Dutchman</option>
                                  <option value="Honduran">Honduran</option>
                                  <option value="Hungarian">Hungarian</option>
                                  <option value="Icelander">Icelander</option>
                                  <option value="Indian">Indian</option>
                                  <option value="Indonesian">Indonesian</option>
                                  <option value="Iranian">Iranian</option>
                                  <option value="Iraqi">Iraqi</option>
                                  <option value="Irishman">Irishman</option>
                                  <option value="Israeli">Israeli</option>
                                  <option value="Italian">Italian</option>
                                  <option value="Jamaican">Jamaican</option>
                                  <option value="Japanese">Japanese</option>
                                  <option value="Jordanian">Jordanian</option>
                                  <option value="Kazakh">Kazakh</option>
                                  <option value="Kenyan">Kenyan</option>
                                  <option value="Korean">Korean</option>
                                  <option value="Kuwaiti">Kuwaiti</option>
                                  <option value="Laotian">Laotian</option>
                                  <option value="Latvian">Latvian</option>
                                  <option value="Lebanese">Lebanese</option>
                                  <option value="Liberian">Liberian</option>
                                  <option value="Libyan">Libyan</option>
                                  <option value="Liechtensteiner">Liechtensteiner</option>
                                  <option value="Lithuanian">Lithuanian</option>
                                  <option value="Luxembourger">Luxembourger</option>
                                  <option value="Macedonian">Macedonian</option>
                                  <option value="Madagascan">Madagascan</option>
                                  <option value="Malawian">Malawian</option>
                                  <option value="Malaysian">Malaysian</option>
                                  <option value="Maldivian">Maldivian</option>
                                  <option value="Malian">Malian</option>
                                  <option value="Maltese">Maltese</option>
                                  <option value="Mauritanian">Mauritanian</option>
                                  <option value="Mauritian">Mauritian</option>
                                  <option value="Mexican">Mexican</option>
                                  <option value="Moldovan">Moldovan</option>
                                  <option value="Monacan">Monacan</option>
                                  <option value="Mongolian">Mongolian</option>
                                  <option value="Montenegrin">Montenegrin</option>
                                  <option value="Moroccan">Moroccan</option>
                                  <option value="Mozambican">Mozambican</option>
                                  <option value="Namibian">Namibian</option>
                                  <option value="Nepalese">Nepalese</option>
                                  <option value="Nicaraguan">Nicaraguan</option>
                                  <option value="Nigerien">Nigerien</option>
                                  <option value="Nigerian">Nigerian</option>
                                  <option value="Norwegian">Norwegian</option>
                                  <option value="Pakistani">Pakistani</option>
                                  <option value="Panamanian">Panamanian</option>
                                  <option value="Paraguayan">Paraguayan</option>
                                  <option value="Peruvian">Peruvian</option>
                                  <option value="Filipino">Filipino</option>
                                  <option value="Pole">Pole</option>
                                  <option value="Portuguese">Portuguese</option>
                                  <option value="Qatari">Qatari</option>
                                  <option value="Romanian">Romanian</option>
                                  <option value="Russian">Russian</option>
                                  <option value="Rwandan">Rwandan</option>
                                  <option value="Saudi">Saudi</option>
                                  <option value="Scot">Scot</option>
                                  <option value="Senegalese">Senegalese</option>
                                  <option value="Serbian">Serbian</option>
                                  <option value="Singaporean">Singaporean</option>
                                  <option value="Slovak">Slovak</option>
                                  <option value="Slovenian">Slovenian</option>
                                  <option value="Somali">Somali</option>
                                  <option value="Spaniard">Spaniard</option>
                                  <option value="Sri-lankan">Sri-lankan</option>
                                  <option value="Sudanese">Sudanese</option>
                                  <option value="Surinamese">Surinamese</option>
                                  <option value="Swazi">Swazi</option>
                                  <option value="Swede">Swede</option>
                                  <option value="Swiss">Swiss</option>
                                  <option value="Syrian">Syrian</option>
                                  <option value="Taiwanese">Taiwanese</option>
                                  <option value="Tadzhik">Tadzhik</option>
                                  <option value="Tanzanian">Tanzanian</option>
                                  <option value="Thai">Thai</option>
                                  <option value="Togolese">Togolese</option>
                                  <option value="Trinidadian">Trinidadian</option>
                                  <option value="Tunisian">Tunisian</option>
                                  <option value="Turk">Turk</option>
                                  <option value="Ugandan">Ugandan</option>
                                  <option value="Ukrainian">Ukrainian</option>
                                  <option value="Kingdom">Kingdom</option>
                                  <option value="United">United</option>
                                  <option value="American">American</option>
                                  <option value="Uruguayan">Uruguayan</option>
                                  <option value="Uzbek">Uzbek</option>
                                  <option value="Venezuelan">Venezuelan</option>
                                  <option value="Vietnamese">Vietnamese</option>
                                  <option value="Welshman">Welshman</option>
                                  <option value="Yemeni">Yemeni</option>
                                  <option value="Yugoslav">Yugoslav</option>
                                  <option value="Zambian">Zambian</option>
                                  <option value="Zimbabwean">Zimbabwean</option>
                                </select>
                                <label for="admission-nationality">Nationality<span
                                    style="color: #F44336;">*</span></label>
                              </div>
                            </div>

                            <div class="col-md-3">
                              <div class="form-group">
                                <input type="text" [(ngModel)]="mStudentEmail" [ngModelOptions]="{standalone: true}"
                                  class="form-control" id="admission-student-email">
                                <label for="admission-student-email">Student Email</label>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <input [(ngModel)]="mStudenNumber" [ngModelOptions]="{standalone: true}" type="text"
                                  class="form-control" id="admission-phone-number" maxlength="10">
                                <label for="admission-phone-number">Contact number</label>
                              </div>
                            </div>
                          </div>




                          <!-- ///// -->
                          <!--  <div class="col-md-12" style="border-bottom: 1px  solid #e6e6e6;margin-bottom: 15px;">
                           <h3 style="font-weight: 100;margin: 0;color: #777777;">Add admission details</h3>
                           <h6 style="color: #b9b9b9;font-weight: 300;margin-top: 5px;"><span style="color: #F44336;">*</span>mandatory fields</h6>
                         </div> -->
                          <div class="">
                            <div class="row" style="margin: 0;">
                              <div class="col-md-12">
                                <h5>Admission details</h5>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <select id="select-academic-year" [(ngModel)]="selectedAcademicYear"
                                    [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="updateSelectedAcademic($event)" name="select1" class="form-control"
                                    style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                                    <option *ngFor="let o of academicYearsList" [value]="o.pkAcademicId">{{o.Year}}
                                    </option>
                                    <!--<option value="0"></option>-->
                                    <!--<option value="1">2016-2017</option>-->
                                    <!--<option value="2">2017-2018</option>-->
                                  </select>
                                  <label for="select-academic-year">Select academic year<span
                                      style="color: #F44336;">*</span></label>
                                </div>
                              </div>

                              <div class="col-md-6">
                                <div class="form-group">
                                  <select [(ngModel)]="admissionBase" [ngModelOptions]="{standalone: true}"
                                    id="admission-base" name="select1" class="form-control"
                                    style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                                    <option value="written">Written exam</option>
                                    <option value="interview">Interview</option>
                                  </select>
                                  <label for="admission-base">Admission base<span
                                      style="color: #F44336;">*</span></label>
                                </div>
                              </div>


                              <div class="col-md-3">
                                <div class="form-group">
                                  <select [(ngModel)]="mAdmissionStream" [ngModelOptions]="{standalone: true}"
                                    id="admission-stream" name="select1" class="form-control"
                                    style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">

                                    <option value="general">General</option>
                                    <option value="management">Management</option>
                                    <option value="sports">Sports</option>
                                  </select>
                                  <label for="admission-stream">Academic Stream<span
                                      style="color: #F44336;">*</span></label>
                                </div>
                              </div>

                              <div class="col-md-3">
                                <div class="form-group">
                                  <select id="admission-select-category" [(ngModel)]="selectedCategory"
                                    [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="updateSelectedCategory($event)" name="select1" class="form-control"
                                    style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                                    <option *ngFor="let o of categoryList" [value]="o.categoryId">{{o.categoryName}}
                                    </option>
                                    <!--<option value="0"></option>-->
                                    <!--<option value="1">Primary</option>-->
                                    <!--<option value="1">Secondary</option>-->
                                  </select>
                                  <label for="admission-select-category">Select class category<span
                                      style="color: #F44336;">*</span></label>
                                </div>
                              </div>


                              <div class="col-md-3">
                                <div class="form-group">
                                  <select id="add-clname" [(ngModel)]="selectedClassSection"
                                    (ngModelChange)="updateSelectedClassSection($event)" name="select1"
                                    class="form-control"
                                    style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                                    <option *ngFor="let o of classSectionList" [value]="o.classid">{{o.classname}}
                                    </option>
                                  </select>
                                  <label for="add-clname">Select class<span style="color: #F44336;">*</span></label>
                                </div>
                              </div>

                              <div class="col-md-3">
                                <div class="form-group">
                                  <select id="add-clname" [(ngModel)]="selectedClassSectionId"
                                    (ngModelChange)="updateSelectedClassSectionId($event)" name="select1"
                                    class="form-control"
                                    style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                                    <option *ngFor="let o of classSections" [value]="o.claaSectionId">{{o.className+" "+
                                      o.classSection}}</option>
                                  </select>
                                  <label for="add-clname">Select class section<span
                                      style="color: #F44336;">*</span></label>
                                </div>
                              </div>



                              <div class="col-md-3">
                                <div class="form-group">
                                  <input [(ngModel)]="mAdmissionNumber" [ngModelOptions]="{standalone: true}"
                                    type="text" class="form-control" id="regular2">
                                  <label for="regular2">Admission number</label>
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div class="form-group">
                                  <input [(ngModel)]="mAdmissionDate" [ngModelOptions]="{standalone: true}" type="text"
                                    class="form-control" id="admission-date" style="text-transform: initial;"
                                    data-provide="datepicker" data-date-format="mm/dd/yyyy">
                                  <label for="admission-dob">Admission date<span style="color: #F44336;">* </span>
                                    (mm/dd/yyyy )</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- ///// -->



                          <div class="col-md-12"
                            style="margin: 1em 0em;border-top: 1px dashed #d8d8d8;border-bottom: 1px dashed #d8d8d8;padding: 1em 0em;">
                            <div class="col-xs-12 text-right">
                              <a *ngIf="nextTabStatus1" href="#tab2" (click)="nexttab('tab2')" data-toggle="tab"
                                style="padding: 15px 20px;border-left: 1px dashed #d0d0d0;">
                                <h3
                                  style="display: inline-block;margin: 0;padding: 2px 10px;border: 1px solid #0885e8;color: #ffffff;font-weight: 400;font-size: 17px;background: #0885e8;">
                                  Next</h3>
                              </a>
                              <a *ngIf="!nextTabStatus1" (click)="validateTab1()"
                                style="cursor:pointer; padding: 15px 20px;border-left: 1px dashed #d0d0d0;">
                                <h3
                                  style="display: inline-block;margin: 0;padding: 2px 10px;border: 1px solid #0885e8;color: #ffffff;font-weight: 400;font-size: 17px;background: #0885e8;">
                                  Next</h3>
                              </a>
                            </div>
                          </div>


                        </div>


                      </div><!--end #tab1 -->


                      <div class="tab-pane card animated bounceInRight" id="tab2" style="padding: 15px 15px 30px 15px;">

                        <div class="col-md-12" style="border-bottom: 1px  solid #e6e6e6;margin-bottom: 15px;">
                          <h3 style="font-weight: 100;margin: 0;color: #777777;">Add parent details</h3>
                          <h6 style="color: #b9b9b9;font-weight: 300;margin-top: 5px;"><span
                              style="color: #F44336;">*</span>mandatory fields</h6>
                        </div>
                        <div class="col-md-12 scrollbar-style"
                          style="min-height: 50vh;max-height: 50vh;overflow: auto;">

                          <div class="row" style="margin: 0;">
                            <div class="col-md-12">
                              <h5>Father's info</h5>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <input [(ngModel)]="mFatherName" [ngModelOptions]="{standalone: true}" type="text"
                                  class="form-control" id="admission-father-name">
                                <label for="admission-father-name">Father's name<span
                                    style="color: #F44336;">*</span></label>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <input [(ngModel)]="mFatherNumber" [ngModelOptions]="{standalone: true}" type="text"
                                  class="form-control" id="regular2" maxlength="10">
                                <label for="regular2">Contact number<span style="color: #F44336;">*</span></label>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <select [(ngModel)]="mFatherOccupation" [ngModelOptions]="{standalone: true}"
                                  id="admission-father-occupation" name="select1" class="form-control"
                                  style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                                  <option value="Agriculture, Food and Natural Resources">Agriculture, Food and Natural
                                    Resources</option>
                                  <option value="Architecture and Construction">Architecture and Construction</option>
                                  <option value="Arts, Audio/Video Technology and Communications">Arts, Audio/Video
                                    Technology and Communications</option>
                                  <option value="Business Management and Administration">Business Management and
                                    Administration</option>
                                  <option value="Education and Training">Education and Training</option>
                                  <option value="Finance">Finance</option>
                                  <option value="Government and Public Administration">Government and Public
                                    Administration</option>
                                  <option value="Health Science">Health Science</option>
                                  <option value="Hospitality and Tourism">Hospitality and Tourism</option>
                                  <option value="Human Services">Human Services</option>
                                  <option value="Information Technology">Information Technology</option>
                                  <option value="Law, Public Safety, Corrections and Security">Law, Public Safety,
                                    Corrections and Security</option>
                                  <option value="Manufacturing">Manufacturing</option>
                                  <option value="Marketing, Sales and Service">Marketing, Sales and Service</option>
                                  <option value="Science, Technology, Engineering and Mathematics">Science, Technology,
                                    Engineering and Mathematics</option>
                                  <option value="Transportation, Distribution and Logistics">Transportation,
                                    Distribution and Logistics</option>
                                  <option value="Others">Others</option>
                                </select>
                                <label for="add-clname">Occupation</label>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <input [(ngModel)]="mFatherQualification" [ngModelOptions]="{standalone: true}"
                                  type="text" class="form-control" id="regular2">
                                <label for="regular2">Educational qualification</label>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-group">
                                <textarea [(ngModel)]="mFatherAddress" [ngModelOptions]="{standalone: true}"
                                  name="textarea1" id="staddress" class="form-control" rows="3"
                                  style="text-transform: initial;border: 1px solid #e8e8e8;padding: 12px 10px;margin-top: 5px;"></textarea>
                                <label for="staddress">Contact Address<span style="color: #F44336;">*</span></label>
                              </div>
                            </div>
                          </div>
                          <div class="row" style="margin: 0;">
                            <div class="col-md-12">
                              <h5>Mother's info</h5>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <input [(ngModel)]="mMotherName" [ngModelOptions]="{standalone: true}" type="text"
                                  class="form-control" id="regular2">
                                <label for="regular2">Mother's name<span style="color: #F44336;">*</span></label>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <input [(ngModel)]="mMotherNumber" [ngModelOptions]="{standalone: true}" type="text"
                                  class="form-control" id="regular2" maxlength="10">
                                <label for="regular2">Contact number<span style="color: #F44336;">*</span></label>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <select [(ngModel)]="mMotherOccupation" [ngModelOptions]="{standalone: true}"
                                  id="admission-mother-occupation" name="select1" class="form-control"
                                  style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                                  <option value="0"></option>
                                  <option value="Agriculture, Food and Natural Resources">Agriculture, Food and Natural
                                    Resources</option>
                                  <option value="Architecture and Construction">Architecture and Construction</option>
                                  <option value="Arts, Audio/Video Technology and Communications">Arts, Audio/Video
                                    Technology and Communications</option>
                                  <option value="Business Management and Administration">Business Management and
                                    Administration</option>
                                  <option value="Education and Training">Education and Training</option>
                                  <option value="Finance">Finance</option>
                                  <option value="Government and Public Administration">Government and Public
                                    Administration</option>
                                  <option value="Health Science">Health Science</option>
                                  <option value="Hospitality and Tourism">Hospitality and Tourism</option>
                                  <option value="Human Services">Human Services</option>
                                  <option value="Information Technology">Information Technology</option>
                                  <option value="Law, Public Safety, Corrections and Security">Law, Public Safety,
                                    Corrections and Security</option>
                                  <option value="Manufacturing">Manufacturing</option>
                                  <option value="Marketing, Sales and Service">Marketing, Sales and Service</option>
                                  <option value="Science, Technology, Engineering and Mathematics">Science, Technology,
                                    Engineering and Mathematics</option>
                                  <option value="Transportation, Distribution and Logistics">Transportation,
                                    Distribution and Logistics</option>
                                  <option value="Others">Others</option>
                                </select>
                                <label for="add-clname">Occupation</label>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <input [(ngModel)]="mMotherQualification" [ngModelOptions]="{standalone: true}"
                                  type="text" class="form-control" id="regular2">
                                <label for="regular2">Educational qualification</label>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-group">
                                <div class="checkbox checkbox-styled">
                                  <label>
                                    <input [(ngModel)]="mMotherSameFatherAddress" [ngModelOptions]="{standalone: true}"
                                      type="checkbox" value="">
                                    <span>Use father's address</span>
                                  </label>
                                </div>
                              </div>
                              <div class="form-group">
                                <textarea [(ngModel)]="mMotherAddress" [ngModelOptions]="{standalone: true}"
                                  name="textarea1" id="staddress" class="form-control" rows="3"
                                  style="text-transform: initial;border: 1px solid #e8e8e8;padding: 12px 10px;margin-top: 5px;"></textarea>
                                <label for="staddress">Contact Address<span style="color: #F44336;">*</span></label>
                              </div>
                            </div>
                          </div>
                          <div class="row" style="margin: 0;">
                            <div class="col-md-12">
                              <h5>Guardian's info</h5>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <input [(ngModel)]="mGuardianName" [ngModelOptions]="{standalone: true}" type="text"
                                  class="form-control" id="regular2">
                                <label for="regular2">Guardian's name<span style="color: #F44336;"></span></label>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <input [(ngModel)]="mGuardianNumber" [ngModelOptions]="{standalone: true}" type="text"
                                  class="form-control" id="regular2" maxlength="10">
                                <label for="regular2">Contact number<span style="color: #F44336;"></span></label>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <select [(ngModel)]="mGuardianOccupation" [ngModelOptions]="{standalone: true}"
                                  id="admission-guardian-occupation" name="select1" class="form-control"
                                  style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                                  <option value="0"></option>
                                  <option value="Agriculture, Food and Natural Resources">Agriculture, Food and Natural
                                    Resources</option>
                                  <option value="Architecture and Construction">Architecture and Construction</option>
                                  <option value="Arts, Audio/Video Technology and Communications">Arts, Audio/Video
                                    Technology and Communications</option>
                                  <option value="Business Management and Administration">Business Management and
                                    Administration</option>
                                  <option value="Education and Training">Education and Training</option>
                                  <option value="Finance">Finance</option>
                                  <option value="Government and Public Administration">Government and Public
                                    Administration</option>
                                  <option value="Health Science">Health Science</option>
                                  <option value="Hospitality and Tourism">Hospitality and Tourism</option>
                                  <option value="Human Services">Human Services</option>
                                  <option value="Information Technology">Information Technology</option>
                                  <option value="Law, Public Safety, Corrections and Security">Law, Public Safety,
                                    Corrections and Security</option>
                                  <option value="Manufacturing">Manufacturing</option>
                                  <option value="Marketing, Sales and Service">Marketing, Sales and Service</option>
                                  <option value="Science, Technology, Engineering and Mathematics">Science, Technology,
                                    Engineering and Mathematics</option>
                                  <option value="Transportation, Distribution and Logistics">Transportation,
                                    Distribution and Logistics</option>
                                  <option value="Others">Others</option>
                                </select>
                                <label for="add-clname">Occupation</label>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <input [(ngModel)]="mGuardianQualification" [ngModelOptions]="{standalone: true}"
                                  type="text" class="form-control" id="regular2">
                                <label for="regular2">Educational qualification</label>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="checkbox checkbox-styled">
                                <label>
                                  <input [(ngModel)]="mGuardianSameFatherAddress" [ngModelOptions]="{standalone: true}"
                                    type="checkbox" value="">
                                  <span>Use father's address</span>
                                </label>
                              </div>
                              <div class="form-group">
                                <textarea [(ngModel)]="mGuardianAddress" [ngModelOptions]="{standalone: true}"
                                  name="textarea1" id="staddress" class="form-control" rows="3"
                                  style="text-transform: initial;border: 1px solid #e8e8e8;padding: 12px 10px;margin-top: 5px;"></textarea>
                                <label for="staddress">Contact Address<span style="color: #F44336;">*</span></label>
                              </div>
                            </div>
                          </div>

                          <div class="col-md-12"
                            style="margin: 1em 0em;border-top: 1px dashed #d8d8d8;border-bottom: 1px dashed #d8d8d8;padding: 1em 0em;">
                            <div class="col-xs-6 text-left">
                              <a href="#tab1" (click)="prevtab('tab1')" data-toggle="tab"
                                style="padding: 15px 20px;border-right: 1px dashed #d0d0d0;">
                                <h3
                                  style="display: inline-block;margin: 0;padding: 2px 10px;border: 1px solid #0885e8;color: #ffffff;font-weight: 400;font-size: 17px;background: #0885e8;">
                                  Back</h3>
                              </a>
                            </div>
                            <div class="col-xs-6 text-right">

                              <a *ngIf="nextTabStatus2" href="#tab4" (click)="nexttab('tab4')" data-toggle="tab"
                                style="padding: 15px 20px;border-left: 1px dashed #d0d0d0;">
                                <h3
                                  style="display: inline-block;margin: 0;padding: 2px 10px;border: 1px solid #0885e8;color: #ffffff;font-weight: 400;font-size: 17px;background: #0885e8;">
                                  Next</h3>
                              </a>
                              <a *ngIf="!nextTabStatus2" (click)="validateTab2()"
                                style="cursor:pointer; padding: 15px 20px;border-left: 1px dashed #d0d0d0;">
                                <h3
                                  style="display: inline-block;margin: 0;padding: 2px 10px;border: 1px solid #0885e8;color: #ffffff;font-weight: 400;font-size: 17px;background: #0885e8;">
                                  Next</h3>
                              </a>



                            </div>
                          </div>


                        </div>
                      </div><!--end #tab2 -->



                      <div class="tab-pane card animated bounceInRight" id="tab4" style="padding: 15px 15px 30px 15px;">
                        <div class="col-md-12"
                          style="padding: 0;border-bottom: 1px  solid #e6e6e6;margin-bottom: 15px;">
                          <div class="col-md-6">
                            <h3 style="font-weight: 100;margin: 0;color: #777777;">Add transport details</h3>
                            <h6 style="color: #b9b9b9;font-weight: 300;margin-top: 5px;">select route for transport</h6>
                          </div>
                        </div>
                        <div class="col-md-12 scrollbar-style"
                          style="min-height: 50vh;max-height: 50vh;overflow: auto;">
                          <div class="row" style="margin: 0;min-height: 300px;">
                            <div class="col-md-12">
                              <h5>Select the route and stop for transport</h5>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <select id="bus-route-selection" [(ngModel)]="selectedBusRoute"
                                    (ngModelChange)="updateSelectedBusRoute($event)" name="select1" class="form-control"
                                    style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                                    <option *ngFor="let o of busRouteList" [value]="o.pkRouteId">{{o.BusName}} -
                                      {{o.BusNumber}} - {{o.RouteName}}</option>
                                  </select>
                                  <label for="add-clname">Route</label>
                                </div>
                              </div>

                              <div class="col-md-6">
                                <div class="form-group">
                                  <select id="bus-stop-selection" [(ngModel)]="selectedBusStop"
                                    (ngModelChange)="updateSelectedBusStop($event)" name="select1" class="form-control"
                                    style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                                    <option *ngFor="let o of busStopList" [value]="o.StopNumber">{{o.BusStopName}}
                                    </option>
                                  </select>
                                  <label for="add-clname">Stop</label>
                                </div>
                              </div>
                              <div class="col-md-12">
                                <div class="form-group">
                                  <input [(ngModel)]="mTotalBusFees" [ngModelOptions]="{standalone: true}" type="text"
                                    class="form-control" id="regular1"
                                    style="padding: 35px 10px;font-size: 20px;border: 1px dashed #e2e2e2;color: darkslategray;"
                                    disabled="disabled">
                                  <label for="regular1">Fare</label>
                                </div>

                                <div class="col-md-12 text-center">
                                  <a href="#tab5" (click)="nexttab('tab5')" data-toggle="tab" style=""
                                    aria-expanded="true">
                                    <h2 style="text-decoration: underline;">Skip now...</h2>
                                  </a>
                                </div>
                              </div>


                            </div>
                          </div>


                          <div class="col-md-12"
                            style="margin: 1em 0em;border-top: 1px dashed #d8d8d8;border-bottom: 1px dashed #d8d8d8;padding: 1em 0em;">
                            <div class="col-xs-6 text-left">
                              <a href="#tab2" (click)="prevtab('tab2')" data-toggle="tab"
                                style="padding: 15px 20px;border-right: 1px dashed #d0d0d0;">
                                <h3
                                  style="display: inline-block;margin: 0;padding: 2px 10px;border: 1px solid #0885e8;color: #ffffff;font-weight: 400;font-size: 17px;background: #0885e8;">
                                  Back</h3>
                              </a>
                            </div>
                            <div class="col-xs-6 text-right">
                              <a href="#tab5" (click)="nexttab('tab5')" data-toggle="tab"
                                style="padding: 15px 20px;border-left: 1px dashed #d0d0d0;">
                                <h3
                                  style="display: inline-block;margin: 0;padding: 2px 10px;border: 1px solid #0885e8;color: #ffffff;font-weight: 400;font-size: 17px;background: #0885e8;">
                                  Next</h3>
                              </a>
                            </div>
                          </div>


                        </div>
                      </div>

                      <div class="tab-pane card animated bounceInRight" id="tab5" style="padding: 15px 15px 30px 15px;">
                        <div class="col-md-12" style="border-bottom: 1px  solid #e6e6e6;margin-bottom: 15px;">
                          <h3 style="font-weight: 100;margin: 0;color: #777777;">Finish admission</h3>
                          <h6 style="color: #b9b9b9;font-weight: 300;margin-top: 5px;">finishing the admission process
                          </h6>
                        </div>
                        <div class="col-md-12 scrollbar-style"
                          style="min-height: 50vh;max-height: 50vh;overflow: auto;padding-top: 3em;">
                          <div class="col-md-8"
                            style="text-align: center;padding: 80px 0px;border: 1px dashed #e8e8e8;">
                            <p class="lead" style="font-size: 25px;color: #868585;margin: 0;">Here you go with new
                              admission!!!</p>
                            <h4 style="color: #6b6b6b;font-weight: 300;">Upload the student photo and click finish to
                              complete the admission</h4>
                          </div>


                          <div class="col-md-4">
                            <div class="cropme-admission student-image"
                              style="width: 150px;min-height: 150px;float: initial;margin: 0 auto;border: 1px dashed  #e0e0e0;">
                              <img src="assets/img/avatar-students.png" class="img-responsive">
                            </div>
                            <div class="col-md-12" style="text-align:center;">
                              <p class="lead"
                                style="color: #9a9a9a;font-size: 13px;display: inline-block;border: 1px solid #f1f1f1;padding: 2px 12px;">
                                Upload student image
                              </p>
                            </div>
                            <div class="col-md-12" style="text-align: center;">
                              <button (click)="finishedAdmission()" type="button"
                                class="btn btn-raised ink-reaction btn-info" data-toggle="dropdown"
                                aria-expanded="false" style="padding: 5px 75px;">
                                Finish <!-- <i class="fa fa-caret-down text-default-light"></i> -->
                              </button>
                            </div>
                          </div>

                          <div class="col-md-12"
                            style="margin: 1em 0em;border-top: 1px dashed #d8d8d8;border-bottom: 1px dashed #d8d8d8;padding: 1em 0em;">
                            <div class="col-xs-6 text-left">
                              <a href="#tab4" (click)="prevtab('tab4')" data-toggle="tab"
                                style="padding: 15px 20px;border-right: 1px dashed #d0d0d0;">
                                <h3
                                  style="display: inline-block;margin: 0;padding: 2px 10px;border: 1px solid #0885e8;color: #ffffff;font-weight: 400;font-size: 17px;background: #0885e8;">
                                  Back</h3>
                              </a>
                            </div>
                          </div>


                        </div>
                      </div><!-- end #tab5 -->
                    </div><!--end .tab-content -->
                    <ul class="pager wizard hidden">
                      <!-- <li class="previous first"><a class="btn-raised" href="javascript:void(0);">First</a></li> -->
                      <li class="previous">
                        <a href="javascript:void(0);" style="padding: 0;border: none;margin: 0;background: none;">
                          <h3 style="margin: 0;display: inline-block;">
                            <i class="md md-label-outline"
                              style="-moz-transform: scale(-1, 1);-webkit-transform: scale(-1, 1);-o-transform: scale(-1, 1);-ms-transform: scale(-1, 1);transform: scale(-1, 1);"></i>
                          </h3>
                          <h4 style="display: inline-block;margin: 0;font-weight: 400;">Back</h4>
                        </a>
                      </li>
                      <!-- <li class="next last"><a class="btn-raised" href="javascript:void(0);">Last</a></li> -->
                      <li class="next">
                        <a href="javascript:void(0);" style="padding: 0;border: none;margin: 0;background: none;">
                          <h4 style="display: inline-block;margin: 0;font-weight: 400;">Continue</h4>
                          <h3 style="margin: 0;display: inline-block;">
                            <i class="md md-label-outline" style=""></i>
                          </h3>
                        </a>
                      </li>
                    </ul>
                  </form>
                </div><!--end #rootwizard -->
              </div><!--end .card-body -->
            </div><!--end .card -->
            <em class="text-caption">New admission</em>
          </div><!--end .col -->
        </div><!--end .row -->
        <!-- END FORM WIZARD -->


      </section>
    </div><!--end #content-->
    <!-- END CONTENT -->



    <!-- Menubar -->
    <!--  -->



  </div><!--end #base-->
  <!-- END BASE -->
</div>